export enum DeviceComplianceCode {
  OrderProcessing = 'EPREP_DEVICE_ORDER_PROCESSING'
}
